import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, patch, put } from '../models/base';

export const fetchAlbum = createAsyncThunk(
  'album/fetchAlbum',
  async (albumId, { rejectWithValue }) => {
    try {
      const response = await get(`/api/albums/${albumId}`);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const updateAlbum = createAsyncThunk(
  'album/updateAlbum',
  async (_, { rejectWithValue, getState }) => {
    const { album } = getState().album;

    if (!album.name) {
      album = { ...album, name: 'Album Name' };
    }
    try {
      const response = await patch(`/albums/${album.id}`, album);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const uploadCoverPhoto = createAsyncThunk(
  'album/uploadCoverPhoto',
  async (uploadedFileData, { rejectWithValue, getState }) => {
    const { album } = getState().album;

    try {
      const queryPath = `/albums/${album.id}/upload_cover_image`;
      const response = await put(queryPath, uploadedFileData);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const sendAlbumShareMail = createAsyncThunk(
  'album/sendAlbumShareMail',
  async (emailList, { rejectWithValue, getState }) => {
    const { album } = getState().album;

    try {
      const queryPath = `/albums/${album.id}/share_album_url`;
      const response = await put(queryPath, { emails: [emailList] });
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const sendDownloadGalleryMail = createAsyncThunk(
  'albums/sendDownloadGalleryMail',
  async (email, { rejectWithValue, getState }) => {
    const { album } = getState().album;

    try {
      const queryPath = `/albums/${album.id}/zip_album?email=${email}`;
      const response = await put(queryPath);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
